import { __assign } from '../../_virtual/_tslib.js';
import React from 'react';
import classnames from 'classnames';
import Image from '../Image/index.js';
import hashIndex from '@deal/hash-index';
import styles from './styles.css.js';

// We will apply one of these classes for users without avatars

var CLASS_PREFIX = 'color-';
var PALETTE = Object.keys(styles).filter(function (key) {
  return key.slice(0, CLASS_PREFIX.length) === CLASS_PREFIX;
}).map(function (className) {
  return styles[className];
}); // Convert the size prop to a pixel dimension so we can request properly sized avatar images

function sizeToDimension(size) {
  switch (size) {
    case 'small':
      return 24;

    case 'medium':
      return 32;

    case 'large':
      return 44;

    case 'xlarge':
      return 64;
  }
}
/**
 * Displays a chat participants photo/avatar, or a consistently colored circle with their initials
 */


var Avatar = function Avatar(_a) {
  var name = _a.name,
      hash = _a.hash,
      src = _a.src,
      _b = _a.size,
      size = _b === void 0 ? 'medium' : _b,
      _c = _a.trimNameToInitials,
      trimNameToInitials = _c === void 0 ? true : _c,
      className = _a.className,
      htmlAttributes = _a.htmlAttributes;
  var imageSize = typeof size === 'number' ? size : sizeToDimension(size);
  var classes = classnames(className, styles.avatar);

  if (src) {
    return React.createElement(Image, {
      src: src,
      height: imageSize,
      width: imageSize,
      className: classes,
      htmlAttributes: htmlAttributes
    });
  } else {
    // Concatenate first and last initials
    var names_1 = name.trim().split(' ');
    var initials = names_1.filter(function (_name, i) {
      return i === 0 || i === names_1.length - 1;
    }).map(function (name) {
      return name.charAt(0).toUpperCase();
    }).join('');
    var avatarLabel = trimNameToInitials ? initials : name; // Choose a consistent color for this user's avatar

    var color = PALETTE[hashIndex(hash || name, PALETTE.length || 1)];
    return React.createElement("div", __assign({
      className: classnames(color, classes),
      style: {
        height: imageSize + "px",
        width: imageSize + "px",
        flexBasis: imageSize + "px",
        lineHeight: imageSize + "px",
        fontSize: Math.round(imageSize / 2.2)
      }
    }, htmlAttributes), avatarLabel);
  }
};

export default Avatar;
//# sourceMappingURL=index.js.map
